import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchStore } from "@/store/useSearchStore";
import { useEffect, useState } from "react";
import InstantAnswerWidget from "../instant-answer-widget/InstantAnswerWidget";
import MovieListWidget from "../movie-list-widget/MovieListWidget";
const SearchDetailWidget = () => {
    const { searchValue, setMovieId } = useSearchStore();
    const [isTagAvailable, setTagAvailable] = useState(false);
    const [value, SetValue] = useState("");
    useEffect(() => {
        const isTagAvailable = (searchValue ?? "").startsWith("movie:");
        const value = (searchValue ?? "").replace("movie:", "").trim();
        setTagAvailable(isTagAvailable);
        if (!isTagAvailable) {
            SetValue("");
            setMovieId("");
            return;
        }
        SetValue(value);
    }, [searchValue]);
    useEffect(() => {
        if (isTagAvailable && value) {
            setMovieId("");
        }
    }, [isTagAvailable, value]);
    useEffect(() => {
        return () => {
            setMovieId("");
        };
    }, []);
    if (!isTagAvailable)
        return (_jsx(InstantAnswerWidget, { query: searchValue }));
    return (_jsx(MovieListWidget, { movieId: value }));
};
export default SearchDetailWidget;
